import FullDot from "../../../../assets/images/icons/ui/dot-filled-blue.svg?react";
import EmptyDot from "../../../../assets/images/icons/ui/dot-outline-gray.svg?react";
import { TermsOfServiceDocument } from "../../../../types/interactiveBrokers";
import { texts } from "../../i18n";
import styles from "./Outline.module.scss";

interface Props {
  language: "en" | "es";
  documents: TermsOfServiceDocument[];
  acceptedDocuments: TermsOfServiceDocument[];
  currentDocument?: TermsOfServiceDocument;
  onDocumentClicked: (document: TermsOfServiceDocument) => void;
  className?: string;
}

const Outline = ({
  language,
  documents,
  currentDocument,
  acceptedDocuments,
  onDocumentClicked: handleDocumentClicked,
  className,
}: Props) => {
  const { container, header, title, accepted, dot } = styles;

  return (
    <div className={`flex flex-col gap-4 ${container} ${className}`}>
      <span className={header}>{texts[language].outline.title}</span>

      <div className="flex flex-col gap-4">
        {documents.map((document) => {
          const isAccepted = acceptedDocuments.includes(document);
          return (
            <div
              key={document.id}
              className={`flex gap-4 items-center  ${
                document === currentDocument || isAccepted ? accepted : ""
              }`}
              onClick={() => handleDocumentClicked(document)}
            >
              <div className={dot}>
                {document === currentDocument || isAccepted ? (
                  <FullDot />
                ) : (
                  <EmptyDot />
                )}
                {/* <div className={line}></div> */}
              </div>

              <div className={`flex flex-col`}>
                <span className={title}>{document.name}</span>
                {document === currentDocument ? (
                  <span>{texts[language].outline.currentDocument}</span>
                ) : (
                  <span>
                    {isAccepted
                      ? texts[language].outline.acceptedDocument
                      : texts[language].outline.pendingDocument}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Outline;
